import { useState, useRef, useEffect } from 'react';
import { FaTwitterSquare, FaFacebookSquare, FaInstagram, FaLinkedin, FaLanguage } from 'react-icons/fa';
import { useI18n } from '@/contexts/I18nContext';

type LocaleCode = 'en' | 'ko';
const LANG_CODES: LocaleCode[] = ['en', 'ko'];

export default function PromoFooter() {
  const year = new Date().getFullYear();
  const { setLang, t, tLocale } = useI18n();

  const [open, setOpen] = useState(false);
  const dropupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropupRef.current && !dropupRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLangSelect = (code: LocaleCode) => {
    setLang(code);
    setOpen(false);
  };

  return (
    <footer className="promo-footer">
      {/* 원본: p.social-icons.text-center.relative */}
      <p className="social-icons">
        <a href="https://twitter.com/GG_Content" target="_blank" rel="noreferrer">
          <FaTwitterSquare />
        </a>
        <a href="https://www.facebook.com/GGContentCom" target="_blank" rel="noreferrer">
          <FaFacebookSquare />
        </a>
        <a href="https://www.instagram.com/gg_content" target="_blank" rel="noreferrer">
          <FaInstagram />
        </a>
        <a href="https://www.linkedin.com/company/ggcontent" target="_blank" rel="noreferrer">
          <FaLinkedin />
        </a>
      </p>

      <p className="copyright">
        &copy; {year} GC Social Media Marketing, Inc. All Rights Reserved&nbsp;&nbsp;&nbsp;
        <a href="/terms_and_conditions/privacy">Privacy policy</a>
      </p>

      {/* 원본: .dropup.lang-dropup — 왼쪽 하단 absolute */}
      <div className="lang-dropup" ref={dropupRef}>
        <button
          type="button"
          className="lang-dropup-toggle"
          onClick={() => setOpen(!open)}
        >
          <FaLanguage style={{ fontSize: 20, marginRight: 6, verticalAlign: 'middle' }} />
          <span className="lang">{t('lang')}</span>
          &nbsp;
          <span className="caret">▲</span>
        </button>
        {open && (
          <ul className="lang-dropup-menu">
            {LANG_CODES.map((code) => (
              <li key={code}>
                <button type="button" onClick={() => handleLangSelect(code)}>
                  {tLocale('lang', code)}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </footer>
  );
}
